var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "onboarding-quicktrial-mobile" }, [
    _c("div", { staticClass: "onboarding-quicktrial-mobile__header" }, [
      _c(
        "div",
        { staticClass: "onboarding-quicktrial-mobile__header-logo" },
        [_c("CompassLogo", { attrs: { type: "logo", width: 170 } })],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "onboarding-quicktrial-mobile__content" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("p", {
          class: [
            "onboarding-quicktrial-mobile__content-title",
            _vm.isDesktop
              ? "typographies-display-small"
              : "typographies-paragraph-large-semibold"
          ],
          domProps: {
            innerHTML: _vm._s(
              _vm.$t.__(
                "pages.onboarding.trial.OnboardingQuicktrialMobile.description",
                {
                  br: "</br>"
                }
              )
            )
          }
        }),
        _vm._v(" "),
        _c("CompassButton", {
          attrs: {
            label: _vm.$t.__(
              "pages.onboarding.trial.OnboardingQuicktrialMobile.button"
            ),
            leftIcon: "richeditor-video",
            size: _vm.isDesktop ? "large" : "medium"
          },
          on: { click: _vm.openRedirectPage }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "onboarding-quicktrial-mobile__content-illustration" },
      [
        _c("img", {
          attrs: {
            src: "/ressources/logged/img/onboarding/onboarding-trial-mobile.png"
          }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }